import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

// English locale bundles — loaded eagerly (default language)
import enCommon from './locales/en/common.json'
import enNav    from './locales/en/nav.json'
import enAuth   from './locales/en/auth.json'
import enErrors from './locales/en/errors.json'
import enModules from './locales/en/modules.json'

// Arabic locale bundles — loaded eagerly to avoid flash on RTL switch
import arCommon  from './locales/ar/common.json'
import arNav     from './locales/ar/nav.json'
import arAuth    from './locales/ar/auth.json'
import arErrors  from './locales/ar/errors.json'
import arModules from './locales/ar/modules.json'

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    supportedLngs: ['en', 'ar'],

    /**
     * Namespaces:
     * - common  → shared UI strings (buttons, status labels, pagination)
     * - nav     → sidebar navigation labels
     * - auth    → login / logout / password flows
     * - errors  → API error code → human message mapping
     * - modules → all feature-module strings (vehicles, alerts, billing, etc.)
     */
    ns: ['common', 'nav', 'auth', 'errors', 'modules'],
    defaultNS: 'common',

    interpolation: {
      escapeValue: false, // React already escapes by default
    },

    detection: {
      // Order: 1) what we last persisted, 2) browser language, 3) fallback
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'i18n_language',
      caches: ['localStorage'],
    },

    /**
     * On every init, i18next-browser-languagedetector reads localStorage['i18n_language']
     * first (order: ['localStorage', 'navigator']) and resolves the language.
     * We DON'T use `lng` here so the detector can do its job.
     */

    resources: {
      en: {
        common:  enCommon,
        nav:     enNav,
        auth:    enAuth,
        errors:  enErrors,
        modules: enModules,
      },
      ar: {
        common:  arCommon,
        nav:     arNav,
        auth:    arAuth,
        errors:  arErrors,
        modules: arModules,
      },
    },
  })

// ── Apply correct dir/lang to <html> immediately on boot ──────────────────────
// Runs synchronously so the very first render already has the right direction.
// The language was resolved above by the detector (localStorage → navigator → 'en').
;(function applyInitialDirection() {
  const lang = (i18n.language ?? localStorage.getItem('i18n_language') ?? 'en').split('-')[0]
  const isRtl = lang === 'ar'
  const root = document.documentElement
  root.setAttribute('dir',  isRtl ? 'rtl' : 'ltr')
  root.setAttribute('lang', lang)
  root.classList.toggle('rtl', isRtl)
})()

export default i18n
